import { ALERTICON, ALERTMSG } from "../enums/index";
import { showAlert } from "../../promptMessages/PromptMessages";
import { mapHttpError } from "./MapHTTPError";

export function handleHttpError(
  error: any,
  customColor?: string,
  fallbackMsg: string = ALERTMSG.SOMEWENTWRONG
) {
  const { status, message } = mapHttpError(error);
  showAlert(
    fallbackMsg,
    `Error (${status}): ${message}`,
    ALERTICON.ERR,
    customColor
  );
}
